import Pager from 'carbon-react/esm/components/pager';

export interface TablePagerProps {
  totalRecords: number;
  pageSize: number;
  currentPage: number;
  onPagination: (newPage: number, pageSize?: number) => void;
  pageSizeSelectionOptions: Array<{ id: string; name: number }>;
}

const TablePager = ({
  totalRecords = 0,
  pageSize,
  currentPage,
  onPagination,
  pageSizeSelectionOptions,
}: TablePagerProps) => {
  return (
    <Pager
      data-role="table-pager-navigation"
      size="small"
      totalRecords={totalRecords}
      showPageSizeSelection
      showTotalRecords
      pageSize={pageSize}
      currentPage={currentPage}
      onPagination={onPagination}
      pageSizeSelectionOptions={pageSizeSelectionOptions}
    />
  );
};

export default TablePager;
